import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import message from '@web-common/components/UI/Message/SiriusMessage';
import { inWindow, apiHolder, apis } from 'api';
import moment from 'moment';
import CloseIcon from '@/images/icons/new_version_close.svg';
import style from './welcome_guide.module.scss';
import { _fGenerateSwitchNumber } from './utils';
import InfoIcon from '@/images/icons/right-arrow.svg';
import { getHistoryState } from '@/components/util/historyState';
const WELCOME_GUIDE = 'welcome_guide';
const SHOW_OLD = 'show_old';
const ACTIVITY_STAT = 'activity_stat';
const SHOW_ACTIVITY = 'show_activity';
const ACTIVITY_FIRST = 'activity_first';
const fromWebmailPattern = /from=login/;
const storeApi = apiHolder.api.getDataStoreApi();
const FROM_LOGIN = 'from_login';
const webmailApi = apiHolder.api.requireLogicalApi(apis.webmailApiImpl);
import { getIn18Text } from 'api';
const activityConf = webmailApi.getTimeRange();
const systemApi = apiHolder.api.getSystemApi();
const { startTime, endTime } = activityConf.yun_bi_ji;
const startFormat = moment(startTime).format('YYYY/MM/DD');
const endFormat = moment(endTime).format('YYYY/MM/DD');
const firstEnter = () => getHistoryState() && getHistoryState().from && getHistoryState().from === 'login';
const getStore = (key, noValue = false) => {
    const result = storeApi.getSync(key);
    if (noValue) {
        if (result.suc && result.data != null) {
            return true;
        }
    }
    else {
        if (result.suc && result.data === 'true') {
            return true;
        }
    }
    return false;
};
export const WelcomeModal = props => {
    const [isActivity, setIsActivity] = useState(false);
    const [visible, setVisible] = useState(false);
    const [showTips, setShowTips] = useState(false);
    const [isKnow, setIsKnow] = useState(false);
    const [isJoin, setIsjoin] = useState(true);
    const [activityId, setActivityId] = useState(0);
    const [hasClosedActivity, setCloseActivity] = useState(true);
    useEffect(() => {
        const state = getHistoryState();
        if (state[SHOW_OLD]) {
            webmailApi.setState(state);
            storeApi.putSync(SHOW_OLD, state[SHOW_OLD] || '2');
        }
        else {
            const result = storeApi.getSync(SHOW_OLD);
            let state = '2';
            if (result.suc && result.data != null) {
                state = result.data;
            }
            webmailApi.setState({
                [SHOW_OLD]: state,
            });
        }
        systemApi.getUserConfig(['ACTIVITY_FIRST']).then(res => {
            const hasClosed = !!((res === null || res === void 0 ? void 0 : res.length) && res[0].value === '1');
            setCloseActivity(hasClosed);
            if (!getStore(WELCOME_GUIDE) && !hasClosed) {
                setVisible(true);
            }
        });
        if (inWindow()) {
            const time = Date.now();
            if (!getStore(WELCOME_GUIDE)) {
                if (time > startTime && time < endTime) {
                    if (!getStore(ACTIVITY_STAT, true)) {
                        webmailApi
                            .getActivityInfo()
                            .then(res => {
                            var _a;
                            console.log(res);
                            const activityInfos = (_a = res.data) === null || _a === void 0 ? void 0 : _a.activityInfos;
                            if (activityInfos != null) {
                                const info = activityInfos.find(item => item.type === 'webmail_lx_note_v2');
                                if (info == null) {
                                    return;
                                }
                                setActivityId(info.activityId);
                                if (info.join === 1) {
                                    setIsjoin(true);
                                    storeApi.putSync(ACTIVITY_STAT, info.activityId + '');
                                }
                                else {
                                    setIsjoin(false);
                                }
                            }
                        })
                            .catch(() => {
                            message.error('获取活动详情失败，请重试');
                        });
                    }
                }
            }
        }
    }, []);
    const setActivityClosedOnline = () => {
        systemApi.setUserConfig([{ field: 'ACTIVITY_FIRST', value: '1' }]).then(() => {
            setCloseActivity(true);
        });
    };
    const showModal = () => {
        setVisible(true);
        setIsActivity(true);
        setIsKnow(getStore(ACTIVITY_STAT, true));
    };
    useEffect(() => {
        if (inWindow()) {
            window.addEventListener(SHOW_ACTIVITY, showModal);
        }
        return () => {
            window.removeEventListener(SHOW_ACTIVITY, showModal);
        };
    }, []);
    useEffect(() => {
        if (!isJoin) {
            if (!getStore(ACTIVITY_FIRST) && !hasClosedActivity) {
                setVisible(true);
                setIsActivity(true);
            }
        }
        else if (firstEnter() && !hasClosedActivity) {
            setVisible(true);
        }
    }, [isJoin, hasClosedActivity]);
    const setKnowStat = () => {
        webmailApi
            .joinActivity({ activityId })
            .then(res => {
            if (res.data) {
                setIsKnow(true);
                storeApi.putSync(ACTIVITY_STAT, activityId + '');
            }
        })
            .catch(err => {
            message.error((err === null || err === void 0 ? void 0 : err.message) || '报名失败，请重试');
        });
    };
    const EntryLeftNode = (React.createElement("div", { className: style.leftContent },
        React.createElement("div", { className: style.contentTitle },
            getIn18Text('QIYEYOUXIANGQUAN'),
            React.createElement("br", null),
            getIn18Text('HUANYINGTIYAN')),
        React.createElement("div", { className: style.contentInfo }, getIn18Text('YOUXIANGANQUANGENG')),
        React.createElement("div", { onClick: () => {
                setVisible(false);
            }, className: style.contentBtn }, getIn18Text('JINRUYOUXIANG')),
        React.createElement("div", { className: style.contentTips },
            getIn18Text('YIYOU'),
            React.createElement("span", { className: style.tipsNumber }, _fGenerateSwitchNumber().toLocaleString()),
            getIn18Text('RENQIANGXIANTIYAN'))));
    const ActivityLeftNode = (React.createElement("div", { className: style.activityLeft },
        React.createElement("div", { className: style.activityTitle }, "\u4F01\u4E1A\u90AE\u7BB1\u5168\u65B0\u6539\u7248"),
        React.createElement("div", { className: style.activityInfoWrapper },
            React.createElement("div", { className: style.activityInfo },
                "\u4EFB\u610F",
                React.createElement("span", { className: style.activityInfoNumber }, "2"),
                "\u5929\u7D2F\u8BA1\u53D1\u4FE1",
                React.createElement("span", { className: style.activityInfoNumber }, "2"),
                "\u5C01"),
            React.createElement("div", { className: style.activityInfo },
                "\u5373\u53EF",
                React.createElement("span", { className: style.activityInfoNumber }, "\u514D\u8D39\u9886\u53D6"),
                "35\u5929\u4E13\u5C5E",
                React.createElement("span", { className: style.activityInfoNumber }, "\u6709\u9053\u4E91\u7B14\u8BB0\u4F1A\u5458"))),
        React.createElement("div", { className: style.activityTips }, "\u90AE\u7BB1\u5B89\u5168\u66F4\u8FDB\u4E00\u6B65\uFF0C\u7CBE\u51C6\u9632\u8BC8\u9A97\uFF0C\u90AE\u4EF6\u534F\u540C\u6548\u7387\u7FFB\u500D\uFF0C\u5D2D\u65B0\u7684\u89C6\u89C9\uFF0C\u9AD8\u6548\u7684\u4EA4\u4E92\u4F53\u9A8C\u3002"),
        React.createElement("div", { className: style.buttonWrapper },
            isKnow ? (React.createElement("div", { onClick: () => {
                    storeApi.putSync(ACTIVITY_FIRST, 'true');
                    setActivityClosedOnline();
                    setVisible(false);
                }, className: style.buttonLeft }, "\u62A5\u540D\u6210\u529F\uFF0C\u901F\u53BB\u5199\u4FE1")) : (React.createElement("div", { onClick: setKnowStat, className: style.buttonLeft }, "\u7ACB\u5373\u62A5\u540D")),
            !isKnow && (React.createElement("div", { onClick: () => {
                    storeApi.putSync(WELCOME_GUIDE, 'true');
                    setVisible(false);
                }, className: style.buttonRight }, "\u653E\u5F03\u9886\u53D6\uFF0C\u76F4\u63A5\u4F53\u9A8C"))),
        React.createElement("div", { className: style.activityTime },
            React.createElement("div", { className: style.timeRange }, "\u6D3B\u52A8\u65F6\u95F4\uFF1A2022.11.14-2022.11.27"),
            React.createElement("div", { className: style.activityInfoBtn, onClick: () => {
                    setShowTips(true);
                } },
                "\u6D3B\u52A8\u89C4\u5219\u8BE6\u60C5",
                React.createElement("img", { style: {
                        marginLeft: '8px',
                    }, src: InfoIcon, alt: "" }))),
        React.createElement(Modal, { visible: showTips, width: 673, centered: true, closeIcon: React.createElement("img", { style: {
                    width: 16,
                    height: 16,
                }, src: CloseIcon }), title: null, footer: null, className: style.modalWrapper, maskClosable: false, onCancel: () => {
                setShowTips(false);
            } },
            React.createElement("div", { className: style.activityTipsWrapper },
                React.createElement("div", { className: style.activityTipsTitle }, "\u4F01\u4E1A\u90AE\u7BB1\u5168\u65B0\u6539\u7248\uFF0C\u9650\u65F6\u4F53\u9A8C\u9886\u798F\u5229"),
                React.createElement("ul", { className: style.activityTipsContent },
                    React.createElement("li", null, "\u6D3B\u52A8\u65F6\u95F4\uFF1A2022/11/14-2022/11/27"),
                    React.createElement("li", null,
                        "\u6D3B\u52A8\u89C4\u5219\uFF1A\u5728\u6D3B\u52A8\u65F6\u95F4\u5185\uFF0C\u5728\u65B0\u7248\u7D2F\u8BA1",
                        React.createElement("span", { className: style.infoMark }, "\u7B7E\u52302\u5929"),
                        "\uFF0C\u5373\u53EF\u83B7\u5F97",
                        React.createElement("span", { className: style.infoMark }, "35\u5929\u6709\u9053\u4E91\u7B14\u8BB0\u4F1A\u5458"),
                        "\uFF01"),
                    React.createElement("li", null, "\u7B7E\u5230\u89C4\u5219\uFF1A\u53D1\u90011\u5C01\u90AE\u4EF6\u5373\u53EF\u5B8C\u6210\u5F53\u5929\u7B7E\u5230\uFF0C\u53D1\u4FE1\u5305\u542B\u56DE\u590D\uFF0C\u8F6C\u53D1\u548C\u5199\u4FE1\u3002\u6D3B\u52A8\u5956\u54C1\u6BCF\u7528\u6237\u9650\u98861\u6B21\u3002"),
                    React.createElement("li", null, "\u5956\u54C1\u53D1\u653E\uFF1A\u83B7\u5F97\u5956\u54C1\u8D44\u683C\u540E\uFF0C\u6211\u4EEC\u4F1A\u57282022/11/28-2022/12/4\u5185\u901A\u8FC7\u90AE\u4EF6\u53D1\u653E\u4E91\u7B14\u8BB0\u4F1A\u5458\u6FC0\u6D3B\u7801\u81F3\u60A8\u7684\u90AE\u7BB1\u3002\u5982\u6709\u7591\u95EE\uFF0C\u53EF\u8054\u7CFBkf@office.163.com"),
                    React.createElement("li", null, "\u8865\u5145\u8BF4\u660E\uFF1A\u672C\u6B21\u6D3B\u52A8\u5956\u54C1\u4E3A\u4F01\u4E1A\u90AE\u7528\u6237\u4E13\u5C5E\u4F1A\u5458\u6743\u76CA\uFF0C\u6D3B\u52A8\u6700\u7EC8\u89E3\u91CA\u6743\u5F52\u7F51\u6613\u4F01\u4E1A\u90AE\u7BB1\u6240\u6709\u3002")),
                React.createElement("div", { className: style.activityTipsBtn },
                    React.createElement("div", { onClick: () => {
                            setShowTips(false);
                        } }, "\u786E\u5B9A"))))));
    return (React.createElement(Modal, { centered: true, width: 1000, title: null, visible: visible, closeIcon: React.createElement("img", { style: {
                width: 16,
                height: 16,
            }, src: CloseIcon }), footer: null, className: style.modalWrapper, maskClosable: false, onCancel: () => {
            setVisible(false);
        }, afterClose: () => {
            const time = Date.now();
            if (time > startTime && time < endTime) {
                storeApi.putSync(ACTIVITY_FIRST, 'true');
            }
            else {
                storeApi.putSync(WELCOME_GUIDE, 'true');
            }
            setActivityClosedOnline();
        }, mask: !showTips },
        React.createElement("div", { className: style.content },
            isActivity ? ActivityLeftNode : EntryLeftNode,
            React.createElement("div", { className: style.rightContent },
                React.createElement("div", { className: style.contentBg })))));
};
